var map = {
	"./calculator.svg": 64758,
	"./cash.svg": 4799,
	"./comments.svg": 55700,
	"./contact.svg": 70838,
	"./four_wheeler.svg": 90307,
	"./four_wheeler_helper.svg": 83122,
	"./four_wheeler_map_icon.svg": 55524,
	"./info.svg": 85126,
	"./locator.svg": 58872,
	"./map_icon.svg": 97204,
	"./others.svg": 9555,
	"./three_wheeler.svg": 54371,
	"./three_wheeler_helper.svg": 97714,
	"./three_wheeler_map_icon.svg": 32708,
	"./two_wheeler.svg": 69553,
	"./two_wheeler_helper.svg": 57916,
	"./two_wheeler_map_icon.svg": 48026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93836;